import React, { useEffect, useState } from "react";
import axios from "axios";
import { alert } from "../../util/Alert";

const RcoinUsdSetting = () => {
  const [rate, setRate] = useState("");
  const [minRCoin, setMinRCoin] = useState("");
  const [loading, setLoading] = useState(false);

  // fetch existing setting
  const getSetting = async () => {
    try {
      const { data } = await axios.get("/user/walletSetting");
      if (data.status) {
        setRate(data.data.rCoinToUsdRate);
        setMinRCoin(data.data.minConvertRCoin);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getSetting();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);
      const { data } = await axios.post("/user/walletSetting", {
        rCoinToUsdRate: rate,
        minConvertRCoin: minRCoin,
      });

      if (data.status) {
        alert("Success", "Conversion settings updated", "success");
      }
    } catch (err) {
      alert("Error", err.response?.data?.message || "Error", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-xl-6 col-lg-8 col-md-10">
        <div className="card">
          <div className="card-header">
            <h4 className="text-dark">rCoin → USD Conversion</h4>
          </div>

          <div className="card-body">
            <div className="form-group mb-3">
              <label>1 rCoin = USD</label>
              <input
                type="number"
                step="0.0001"
                className="form-control"
                value={rate}
                onChange={(e) => setRate(e.target.value)}
                placeholder="e.g. 0.01"
              />
            </div>

            <div className="form-group mb-3">
              <label>Minimum rCoin for Conversion</label>
              <input
                type="number"
                className="form-control"
                value={minRCoin}
                onChange={(e) => setMinRCoin(e.target.value)}
                placeholder="e.g. 100"
              />
            </div>

            <button
              className="btn btn-warning"
              onClick={handleSave}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Settings"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RcoinUsdSetting;
